module.exports = __webpack_public_path__ + "static/media/egg_img_suiji.54984484.png";